<template>
  <Modal :title="title" :showModal="showModal" class="history-form">
    <template v-slot:body>
      <div class="vertical-timeline vertical-timeline--animate vertical-timeline--one-column">
        <div v-for="(item, index) in data" :key="index" class="vertical-timeline-item vertical-timeline-element">
          <span class="vertical-timeline-element-icon bounce-in">
            <i class="badge badge-dot badge-dot-xl badge-success">&nbsp;</i>
          </span>
          <div class="vertical-timeline-element-content bounce-in">
            <h4 class="timeline-title">{{ item.action }}</h4>
            <p class="timeline-user"><i class="lnr-user"></i>{{ item.user }}</p>
            <div class="description">
              <div class="column-design-inner">
                <div v-if="item.description.name" class="design-title select-all font-weight-bold">
                  {{ item.description.name }}
                </div>
                <div class="design-main">
                  <div class="design-summary mt-2">
                    <div v-if="item.description.status" class="design-status">
                      <label>Status:&nbsp;</label><span>{{ item.description.status_label }}</span>
                    </div>
                  </div>
                  <div class="design-meta">
                    <template v-if="item.description.attributes">
                      <div v-for="(attribute, key) in item.description.attributes" :key="key" class="meta-group size">
                        <label class="text-capitalize">{{ key }}:&nbsp;</label><span class="select-all" v-html="attribute.join('\n')"></span>
                      </div>
                    </template>
                    <template v-if="item.description.note">
                      <p class="meta-group note">
                        <label>Note: </label>
                      </p>
                      <ul>
                        <li v-for="(note, key) in item?.description?.note" :key="key" v-html="note?.replace('\n', '<br>')"></li>
                      </ul>
                    </template>
                  </div>
                  <div v-if="item.description.designs && Object.keys(item.description.designs).length > 0" class="list">
                    <span class="title">Designs: </span>
                    <p>
                      <a v-for="(url, designIndex) in item.description.designs" :key="designIndex" :href="url" target="_blank">{{ url }}</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <span v-if="item.time" class="vertical-timeline-element-date" v-html="$util.timestampToDateTime(item.time, true)"></span>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  data() {
    return {
      data: []
    }
  },
  computed: {
    title() {
      return 'History'
    },
    action() {
      return 'history'
    },
    storeId() {
      return this.config?.storeId
    },
    designId() {
      return this.config?.data?._id
    },
    getUri() {
      return `design/history/${this.designId}`
    }
  },
  methods: {
    setUpData({ status, data }) {
      if (status == 'success') {
        this.showModal = true
        this.data = data
      }
    }
  },
  props: {
    config: Object
  }
}
</script>
